import { date, object, string } from "yup";

export const getValidation = () => {
  const validationSchema = object().shape({
    medication: string()
      .nullable()
      .required("Name can't be blank.")
      .default(""),
    dose: string()
      .nullable()
      .required()
      .default(""),
    frequency: string()
      .required()
      .nullable()
      .default(null),
    lastGivenAt: date()
      .required("Date and Time of Last Given can’t be blank.")
      .nullable()
      .default(null)
  });

  return { validationSchema };
};
